export default __webpack_public_path__ + "static/media/hero_640.d127a879.jpg";